import { withStyles } from '@material-ui/core';
import { withAppConfig } from '../../../../../appConfigContext';
import ExceptionAndReturnDetails from './ExceptionAndReturnDetails';
import appConstants from '../../../../../appConstants';
import Label from './common/Label';
import Value from './common/Value';
import { EXCEPTION_FLOW } from '../DriverPopUp/common/constants';
import { parseExceptionConfig } from '../DriverPopUp/EditStopDialog/ProcessDelivery/ExceptionDetails/utils';

const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  labelContainer: {
    marginBottom: 8
  },
  sectionContainer: {
    marginBottom: 8
  },
  detailsContainer: {
    display: 'flex'
  }
});

const OSNDDetails = ({ classes, exceptionDetail, exceptionList, configJSON }) => {
  const exceptionFlow = parseExceptionConfig(configJSON?.exceptionConfig)?.exceptionFlow;
  const isBothFlow = exceptionFlow === EXCEPTION_FLOW.BOTH;
  const adeNumber = isBothFlow
    ? exceptionDetail?.find((ex) => ex?.adeNumber != null && ex.adeNumber !== '')?.adeNumber
    : null;

  return (
    <div className={classes.container}>
      <div className={classes.labelContainer}>
        <Label labelText="OS & D DETAILS" />
      </div>
      {adeNumber && (
        <div className={classes.sectionContainer}>
          <Value value={`ADE# ${adeNumber}`} />
        </div>
      )}
      {exceptionDetail?.map((exception) => (
        <div key={exception?.exceptionCode ?? exception?.code} className={classes.sectionContainer}>
          <Value
            value={
              exceptionList.find(
                (exceptionType) => exceptionType.value === exception?.exceptionCode
              )?.labelText
            }
          />
          <div className={classes.detailsContainer}>
            <ExceptionAndReturnDetails detail={exception} type={appConstants.DELIVERY_CODE.DE} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default withAppConfig(withStyles(styles)(OSNDDetails));
